import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { Notification } from "../pages/api";
import { INotification } from "../models";

const initialState: Notification = {
  list: [],
};

const MAX_NOTIFICATIONS = 100;

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    addNotification: (state: any, action: PayloadAction<INotification>) => {
      state.list = [action.payload, ...state.list].slice(0, MAX_NOTIFICATIONS);
    },
    setNotifications: (
      state: any,
      action: PayloadAction<Array<INotification>>
    ) => {
      state.list = action.payload.slice(0, MAX_NOTIFICATIONS);
    },
  },
});

// Action creators are generated for each case reducer function
export const { addNotification, setNotifications } = notificationSlice.actions;

export default notificationSlice.reducer;
